import { themedUseStyletron } from '../../../theme/customTheme'
import { IWindowContact } from './types'
import { FormattedMessage } from 'react-intl';
import { Block } from 'baseui/block';
import { ObjectBooleanTimeline } from '../../../features/Charts/ObjectBooleanTimeline';
import { LastXDaysLabel } from '../SensorDigital/LastXDaysLabel';
import { getTimeRangeFromTimespan } from '../../../utils/timeUtils';


export const InsightsPanel = (props: IWindowContact) => {
    const [, theme] = themedUseStyletron();
    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);

    return (
        <>
            <Block marginTop={theme.sizing.scale800}></Block>
            <LastXDaysLabel days={7}></LastXDaysLabel>
            <ObjectBooleanTimeline label={<FormattedMessage id="Devices.OPEN" defaultMessage="OPEN" />} currentValue={props.isOpen} onColor={theme.colors.negative500} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOpen'}></ObjectBooleanTimeline>
        </>
    )
}
